export default {"src":"/_next/static/media/badge-google-en.0ca7dbc0.svg","height":41,"width":135,"blurWidth":0,"blurHeight":0};